import cookiesBM from './cookies';
import imprintBM from './imprint';
import privacyBM from './privacy';
import termsBM from './termsofuse';
import otConfig from './otConfig';
import gaConfig from './ga';
import { getGAKey } from 'helpers/googleAnalitics/GAandGTM';
import getStaticUrl from 'helpers/staticContent';

const { ga: gaId, gtm } = getGAKey(gaConfig);

export default {
  ga: gaId,
  gtm,
  title: 'Outpost',
  landingImg: `${getStaticUrl()}/my-customer-space/Landing_BM.png`,
  favicon:
    'https://outpost24.com/wp-content/uploads/2023/05/cropped-O24_favicon_512_b_a-32x32.png',
  keyLoginConfig: 'birthDate',
  langs: ['en', 'es', 'fr', 'de', 'it', 'nl'],
  defaultLang: 'en',
  faq: [
    { from: 1, to: 19, notShowed: [8, 13] },
    { from: 20, to: 28, notShowed: [21, 22, 23, 24, 25, 28] },
    { from: 29, to: 47 },
  ],
  cookies: cookiesBM,
  imprint: imprintBM,
  privacy: privacyBM,
  terms: termsBM,
  logo: {
    src: 'https://outpost24.com/wp-content/uploads/2023/05/01-o24-color.svg',
    alt: 'Back Market',
    width: '194.56px',
  },
  footerlogo: {
    src: 'https://outpost24.com/wp-content/uploads/2023/05/01-o24-color.svg',
    alt: 'Footer Back Market',
  },
  company: 'bolttech',
  otScript: otConfig,
  footer: [
    {
      label: 'terms_of_use',
      link: '/terms-of-use',
    },
    {
      label: 'imprint',
      link: '/imprint',
    },
    {
      label: 'faq',
      link: '/faq',
    },
  ],
};
